import React from "react";
import { object, array, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Organism1 from "./Organism1";
import Organism2 from "./Organism2";
import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";

import { getSlug, getCollectionName } from "../../utils/utils";

import "./fiveOpinionStories.m.css";

const FiveOpinionStories = ({ collection, sections, publisherAttributes, domainSlug }) => {
  const stories =
    collection.items.length > 0 && collection.items.filter((collectionItem) => collectionItem.type === "story");

  const navigateTo = get(collection, ["associated-metadata", "navigate_to"], "");
  const navigateToTitle = get(collection, ["associated-metadata", "navigate_to_title"], "");

  const collectionSlug = navigateTo ? `/${navigateTo}` : getSlug(collection, sections, domainSlug);
  const collectionName = getCollectionName(collection, navigateToTitle);

  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);

  return stories.length ? (
    <div styleName="base" className="base" data-testid="five-story-cards">
      {showCollectionName && (
        <CollectionTitleWithArrow collectionName={collectionName} collectionSlug={collectionSlug} updatedFont={true} />
      )}
      <div styleName={`container ${publisherAttributes.lang === "en" ? "en-container" : ""}`}>
        <Organism1 story={stories[0]} />
        {stories.length > 1 && <Organism2 stories={stories.slice(1, 5)} publisherLang={publisherAttributes.lang} />}
      </div>
    </div>
  ) : null;
};

FiveOpinionStories.storyLimit = 5;

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
});

FiveOpinionStories.propTypes = {
  collection: object.isRequired,
  sections: array,
  publisherAttributes: object,
  domainSlug: string,
};

export default connect(mapStateToProps, null)(FiveOpinionStories);
